
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/egypt/about-fhs-egypt",
      function () {
        return require("private-next-pages/egypt/about-fhs-egypt.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/egypt/about-fhs-egypt"])
      });
    }
  